import React from "react";

const TextMetricIcon = () => {
  return (
    <svg width="25" height="23" viewBox="0 0 25 23" xmlns="http://www.w3.org/2000/svg">
      <g fillRule="nonzero" fill="none">
        <path
          d="M3 6v8c0 1.1045695.8954305 2 2 2h8.3335L16 18h2.3333l-4-3H5.5c-.82842712 0-1.5-.6715729-1.5-1.5V5H1.5c-.2759825.00038557-.49961443.2240175-.5.5V6h2zM23.5 1.002H22V12.5c0 .2761424-.2238576.5-.5.5H18v3.5l2 1.5v-4h3.5c.2761424 0 .5-.2238576.5-.5V1.502c0-.27614237-.2238576-.5-.5-.5z"
          className="icon icon__shade"
        />
        <path
          d="M19.5 5h-10c-.27614237 0-.5.22385763-.5.5 0 .27614237.22385763.5.5.5h10c.2761424 0 .5-.22385763.5-.5 0-.27614237-.2238576-.5-.5-.5zM19.5 9h-10c-.27614237 0-.5.22385763-.5.5 0 .27614237.22385763.5.5.5h10c.2761424 0 .5-.22385763.5-.5 0-.27614237-.2238576-.5-.5-.5z"
          className="icon icon__line"
        />
        <path
          d="M23.5.002h-18c-.82842712 0-1.5.67157287-1.5 1.5V4H1.5C.67157287 4 0 4.67157288 0 5.5v11.998c0 .8284271.67157287 1.5 1.5 1.5H4v3c-.00029424.2662533.10550862.5216511.2940033.7096954.18849468.1880443.44414488.2932358.7103967.2923046.2152383-.0003533.42443645-.0711983.5956-.2017l5.0664-3.8c.3636 0 8.7112.021 9.07-.0378.0841241.0255254.1713148.0395527.2592.0417.2662865.0009314.5219672-.1042876.7104676-.2923752C20.8945681 18.5217372 21.0003475 18.2662879 21 18v-3h2.5c.8284271 0 1.5-.6715729 1.5-1.5V1.502c0-.82842713-.6715729-1.5-1.5-1.5zM10.3306 18l-.2642.1982L5 21.998V18H4l-2.5-.002c-.27614237 0-.5-.2238576-.5-.5V5.5c.00038557-.2759825.2240175-.49961443.5-.5H4v8.5c0 .8284271.67157288 1.5 1.5 1.5h8.8335l4 3h-8.0029zM24 13.5c0 .2761424-.2238576.5-.5.5H20v4l-5.0662-3.8-.2668-.2H5.5c-.27614237 0-.5-.2238576-.5-.5V1.502c0-.27614237.22385763-.5.5-.5h18c.2761424 0 .5.22385763.5.5V13.5z"
          className="icon icon__line"
        />
      </g>
    </svg>
  );
};
export default TextMetricIcon;
